import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { TriggerType } from '../../../builder.types';
import { CardBase } from '../builder-cards.types';
import { FieldDef } from 'app/core/models';
import { FieldDefsState } from 'app/state/fields/state';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-automation-builder-triggers-setup-card',
  templateUrl: './triggers-setup.component.html',
  styleUrls: ['./triggers-setup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TriggersSetupCardComponent extends CardBase implements OnInit {
  @Input() formData: any;

  TriggerType = TriggerType;
  fieldDefs: FieldDef[];

  constructor(protected readonly store: Store) {
    super(store);
  }

  ngOnInit(): void {
    this.fieldDefs = this.store.selectSnapshot(FieldDefsState.getFieldDefs);
  }

  getField(fieldName: string): FieldDef {
    return this.fieldDefs.find((x) => x.name === fieldName && x.related_to_type === this.automation.target_model);
  }
}
